import { type PropsWithChildren, useMemo } from 'react';
import { type Theme, ThemeProvider, createTheme } from '@mui/material';
import { useIntl } from '@lingoda/i18n';
import { type AcceptedLang } from '@lingoda/env';

interface Props {
    locales: Record<(typeof mapLocaleToMuiLang)[AcceptedLang], object>;
    theme: Theme;
}

export const ThemeProviderLocalized = ({ children, locales, theme }: PropsWithChildren<Props>) => {
    const { locale } = useIntl();

    const themeResult = useMemo(() => {
        const muiLocale = mapLocaleToMuiLang[locale as AcceptedLang];
        const localization = locales[muiLocale];
        const localizedTheme = localization ? createTheme(theme, localization) : theme;

        return localizedTheme;
    }, [locales, locale, theme]);

    return <ThemeProvider theme={themeResult}>{children}</ThemeProvider>;
};

const mapLocaleToMuiLang = {
    de: 'deDE',
    en: 'enUS',
    es: 'esES',
    fr: 'frFR',
    it: 'itIT',
    pl: 'plPL',
    pt_BR: 'ptBR',
    ru: 'ruRU',
    tr: 'trTR',
} as const;
